<template>
    <accordion-item show-open>
        <h2 slot="header">
            Average Past &amp; Future Losses
        </h2>
        <p v-if="chosenRates.length > 1" class="u-text-center u-no-margin u-margin-bottom-40">
            A comparison between discount rates {{ chosenRates[0] }} and {{ chosenRates[1] }} in relation to the average
            past, future and total losses within your book of business.
        </p>
        <p v-else class="u-text-center u-no-margin u-margin-bottom-40">
            A comparison between the average past and future losses for the {{ chosenRates[0] }} discount rate within
            your book of business.
        </p>
        <div class="u-d-flex u-flex-center p-discount-rate-comparison__pie-container">
            <pie v-for="rate in chosenRates" title="Discount Rate" :rate="rate" :total="averageTotal(rate)"
                 :labels="['Past Losses', 'Future Losses']" :dataset="dataset(rate)"></pie>
        </div>
        <div class="u-text-center">
            <chart-legend
                    :values="[
                    'Past Losses',
                    'Future Losses'
                    ]"
                    :legendWidth="chartLegendWidth"
                    marginTop="30"
                    marginBottom="30">
            </chart-legend>
        </div>
        <pie-summary v-if="chosenRates.length > 1" :rates="chosenRates" :data="[dataset(chosenRates[0]),dataset(chosenRates[1])]" />
        <pie-summary v-else :rates="chosenRates" :data="[dataset(chosenRates[0]),dataset(chosenRates[0])]" />
    </accordion-item>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import AccordionItem from 'components/accordion/AccordionItem';
    import Pie from 'pages/discount-rate-comparison/components/charts/Pie';
    import ChartLegend from 'components/chart/Legend';
    import PieSummary from '../tables/PieSummary';

    export default {
        name: 'average-past-future',
        components: {
            AccordionItem,
            Pie,
            ChartLegend,
            PieSummary
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
            ]),
            ...mapGetters('discountRateComparison', [
                'averageDataset',
                'averageTotal',
            ]),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            chartLegendWidth() {
                switch (true) {
                    case this.theCurrentWidth <= 700:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 1024:
                        return 70;
                        break;
                    default:
                        return 50;
                }
            },
            gapClass: {
                get() {
                    return this.chosenRates.length >= 2
                        ? 'flex-grid__g-1'
                        : 'flex-grid__g-3';
                },
            },
        },
        methods: {
            dataset(rate) {
                return [{
                    data: this.averageDataset(rate),
                    backgroundColor: [
                        '#45BFFC',
                        '#3DF2C3',
                    ],
                    borderWidth: 0,
                }];
            },
        },
    }
</script>


// WEBPACK FOOTER //
// AveragePastFutureLosses.vue?1b75c10a